var map = {
	"./calendar/calendar.module": [
		"./src/app/main/pages/dashboard/calendar/calendar.module.ts",
		"calendar-calendar-module"
	],
	"./chat/chat.module": [
		"./src/app/main/pages/dashboard/chat/chat.module.ts",
		"default~chat-chat-module~contacts-contacts-module",
		"common",
		"chat-chat-module"
	],
	"./company/company.module": [
		"./src/app/main/pages/dashboard/company/company.module.ts",
		"default~company-company-module~contacts-contacts-module",
		"common",
		"company-company-module"
	],
	"./contacts/contacts.module": [
		"./src/app/main/pages/dashboard/contacts/contacts.module.ts",
		"default~chat-chat-module~contacts-contacts-module",
		"default~contacts-contacts-module~profile-profile-module",
		"default~company-company-module~contacts-contacts-module",
		"common",
		"contacts-contacts-module"
	],
	"./file-management/file-management.module": [
		"./src/app/main/pages/dashboard/file-management/file-management.module.ts",
		"file-management-file-management-module"
	],
	"./gantt-chart/gantt-chart.module": [
		"./src/app/main/pages/dashboard/gantt-chart/gantt-chart.module.ts",
		"common",
		"gantt-chart-gantt-chart-module"
	],
	"./notifications/notifications.module": [
		"./src/app/main/pages/dashboard/notifications/notifications.module.ts",
		"default~app-main-pages-dashboard-dashboard-module~notifications-notifications-module",
		"common"
	],
	"./pages/basic-setting/basic-setting.module": [
		"./src/app/main/pages/subtraid-employee/pages/basic-setting/basic-setting.module.ts",
		"common",
		"pages-basic-setting-basic-setting-module"
	],
	"./pages/employee-profile/employee-profile.module": [
		"./src/app/main/pages/subtraid-employee/pages/employee-profile/employee-profile.module.ts",
		"default~app-main-pages-register-register-2-module~pages-employee-profile-employee-profile-module~pag~1f63e6da",
		"common",
		"pages-employee-profile-employee-profile-module"
	],
	"./pages/platform-improvement-requests/platform-improvement-requests.module": [
		"./src/app/main/pages/subtraid-employee/pages/platform-improvement-requests/platform-improvement-requests.module.ts",
		"pages-platform-improvement-requests-platform-improvement-requests-module"
	],
	"./pages/stakeholder-profile/stakeholder-profile.module": [
		"./src/app/main/pages/stakeholder-users/pages/stakeholder-profile/stakeholder-profile.module.ts",
		"default~app-main-pages-register-register-2-module~pages-employee-profile-employee-profile-module~pag~1f63e6da",
		"common",
		"pages-stakeholder-profile-stakeholder-profile-module"
	],
	"./pages/stakeholder-projects/stakeholder-projects.module": [
		"./src/app/main/pages/stakeholder-users/pages/stakeholder-projects/stakeholder-projects.module.ts",
		"pages-stakeholder-projects-stakeholder-projects-module"
	],
	"./pages/subtraid-employee-users/subtraid-employee-users.module": [
		"./src/app/main/pages/subtraid-employee/pages/subtraid-employee-users/subtraid-employee-users.module.ts",
		"default~app-main-pages-resetpassword-resetpassword-module~pages-subtraid-employee-users-subtraid-emp~b3ccfa40",
		"common",
		"pages-subtraid-employee-users-subtraid-employee-users-module"
	],
	"./product-improvement/product-improvement.module": [
		"./src/app/main/pages/dashboard/product-improvement/product-improvement.module.ts",
		"product-improvement-product-improvement-module"
	],
	"./profile/profile.module": [
		"./src/app/main/pages/dashboard/profile/profile.module.ts",
		"default~contacts-contacts-module~profile-profile-module",
		"common",
		"profile-profile-module"
	],
	"./request-for-proposal/request-for-proposal.module": [
		"./src/app/main/pages/dashboard/request-for-proposal/request-for-proposal.module.ts",
		"request-for-proposal-request-for-proposal-module"
	],
	"./scrumboard/scrumboard.module": [
		"./src/app/main/pages/dashboard/scrumboard/scrumboard.module.ts",
		"common",
		"scrumboard-scrumboard-module"
	],
	"./timesheets/timesheets.module": [
		"./src/app/main/pages/dashboard/timesheets/timesheets.module.ts",
		"timesheets-timesheets-module"
	],
	"app/main/pages/404/error-404.module": [
		"./src/app/main/pages/404/error-404.module.ts",
		"app-main-pages-404-error-404-module"
	],
	"app/main/pages/comfirmation/comfirmation.module": [
		"./src/app/main/pages/comfirmation/comfirmation.module.ts",
		"app-main-pages-comfirmation-comfirmation-module"
	],
	"app/main/pages/dashboard/dashboard.module": [
		"./src/app/main/pages/dashboard/dashboard.module.ts",
		"default~app-main-pages-dashboard-dashboard-module~notifications-notifications-module",
		"common",
		"app-main-pages-dashboard-dashboard-module"
	],
	"app/main/pages/forgot-password-2/forgot-password-2.module": [
		"./src/app/main/pages/forgot-password-2/forgot-password-2.module.ts",
		"app-main-pages-forgot-password-2-forgot-password-2-module"
	],
	"app/main/pages/login/login-2.module": [
		"./src/app/main/pages/login/login-2.module.ts",
		"app-main-pages-login-login-2-module"
	],
	"app/main/pages/register/register-2.module": [
		"./src/app/main/pages/register/register-2.module.ts",
		"default~app-main-pages-register-register-2-module~pages-employee-profile-employee-profile-module~pag~1f63e6da",
		"common",
		"app-main-pages-register-register-2-module"
	],
	"app/main/pages/resetpassword/resetpassword.module": [
		"./src/app/main/pages/resetpassword/resetpassword.module.ts",
		"default~app-main-pages-resetpassword-resetpassword-module~pages-subtraid-employee-users-subtraid-emp~b3ccfa40",
		"common",
		"app-main-pages-resetpassword-resetpassword-module"
	],
	"app/main/pages/stakeholder-login/stakeholder-login.module": [
		"./src/app/main/pages/stakeholder-login/stakeholder-login.module.ts",
		"app-main-pages-stakeholder-login-stakeholder-login-module"
	],
	"app/main/pages/stakeholder-users/stakeholder-users.module": [
		"./src/app/main/pages/stakeholder-users/stakeholder-users.module.ts",
		"common",
		"app-main-pages-stakeholder-users-stakeholder-users-module"
	],
	"app/main/pages/subtraid-admin-login/subtraid-admin-login.module": [
		"./src/app/main/pages/subtraid-admin-login/subtraid-admin-login.module.ts",
		"app-main-pages-subtraid-admin-login-subtraid-admin-login-module"
	],
	"app/main/pages/subtraid-employee/subtraid-employee.module": [
		"./src/app/main/pages/subtraid-employee/subtraid-employee.module.ts",
		"common",
		"app-main-pages-subtraid-employee-subtraid-employee-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;